export const getRowIndex = (page: number, index: number) =>
  (page - 1) * 10 + index + 1;
